<ll-titulo>Crear planificación</ll-titulo>
<ll-toolnavbar></ll-toolnavbar>

<planificaciones-edit [planificacionId]="planificacionId"></planificaciones-edit>
